import { forwardRef, type Ref, type SVGProps } from "react";
const IconVideoPlayOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 4h-1V6h1ZM4 22V10h24v12ZM7 6h2v2H7Zm16 0h2v2h-2Zm-2 2h-2V6h2Zm-4 0h-2V6h2Zm-4 0h-2V6h2ZM5 6v2H4V6ZM4 26v-2h1v2Zm3 0v-2h2v2Zm4 0v-2h2v2Zm4 0v-2h2v2Zm4 0v-2h2v2Zm4 0v-2h2v2Zm4 0v-2h1v2Z" />
    <path d="m19.51 15.05-6.06-3.91A.9.9 0 0 0 13 11a.9.9 0 0 0-.49.15 1.12 1.12 0 0 0-.48.95v7.8a1.12 1.12 0 0 0 .48 1 .9.9 0 0 0 .49.1.9.9 0 0 0 .48-.14L19.51 17a1.17 1.17 0 0 0 0-1.9ZM14 18.12v-4.24L17.3 16Z" />
  </svg>
);
const ForwardRef = forwardRef(IconVideoPlayOutlineSVG);
ForwardRef.displayName = "IconVideoPlayOutline";
export { ForwardRef as IconVideoPlayOutline };
